import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-fs-header',
  templateUrl: './filesystem-header.component.html',
  styleUrls: ['./filesystem-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileSystemHeaderComponent {
  @Output() closeModalHandler: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}
}
